import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import ApiService from "src/services/ApiService";
import ChangeThumbnailPost from "./ChangeThumbnailPost";
import Layout from "src/page/home/components/Layout";
import ChangeContentPost from "./ChangeContentPost";

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    paddingTop: "100px",
    paddingBottom: "100px",
  },
  container: {
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "1000px",
  },
}));

const getIncrementId = (link) => {
  if (!link) {
    return "";
  }

  const pattern = /-(\d+)\.html/;
  const [_, incrementId] = pattern.exec(link) || [];
  if (incrementId) {
    return incrementId;
  }

  return "";
};
const getPostId = (link) => {
  if (!link) {
    return "";
  }
  const pattern = new RegExp(`/posts/edit/(.*)`, "g");
  const [_, postId] = pattern.exec(link) || [];
  if (postId) {
    return postId;
  }

  return "";
};

const ToolChangeThumbnail = () => {
  const classes = useStyles();
  const [searchedState, setSearchedState] = useState(false);
  const [link, setLink] = useState("");
  const [formError, setFormError] = useState(true);
  const [posts, setPosts] = useState([]);
  const [backdropStatus, setBackdropStatus] = useState(false);
  const [snackBarStatus, setSnackBarStatus] = useState(false);
  const [snackBarData, setSnackBarData] = useState(null);
  const checkFormStatus = () => {
    setFormError(link ? false : true);
  };
  const onSubmit = async (e) => {
    setSearchedState(true);
    e.preventDefault();
    const increment_id = getIncrementId(link);
    const postId = getPostId(link);
    if (postId || increment_id) {
      setBackdropStatus(true);
    }
    if (postId) {
      const params = new URLSearchParams({ _id: postId });
      const postsData =
        (await ApiService.get(`/posts/default?${params}`)) || [];
      setPosts(postsData);
    }
    if (increment_id) {
      const params = new URLSearchParams({ increment_id });
      const postsData =
        (await ApiService.get(`/posts/default?${params}`)) || [];
      setPosts(postsData);
    }
    if (postId || increment_id) {
      setBackdropStatus(false);
    }
  };
  const updatePost = async (post, updateData = {}) => {
    if (!post) {
      return null;
    }
    setBackdropStatus(true);
    const data = await ApiService.put(
      `/posts/designer-tools/${post.id}`,
      updateData
    );
    console.log(data);
    showSnackBar({
      mess: "Đã cập nhật",
      type: "success",
    });
    setBackdropStatus(false);
    return data;
  };
  const updatePostThumbnail = async (post, updateData = {}) => {
    if (!post) {
      return null;
    }
    // setBackdropStatus(true);
    const data = await ApiService.put(
      `/posts/designer-tools/thumbnail/${post.id}`,
      updateData
    );
    // showSnackBar({
    //   mess: "Đã cập nhật",
    //   type: "success",
    // });
    // setBackdropStatus(false);
    return data;
  };

  const updatePostCover = async (post, updateData = {}) => {
    if (!post) {
      return null;
    }
    // setBackdropStatus(true);
    const data = await ApiService.put(
      `/posts/designer-tools/cover/${post.id}`,
      updateData
    );
    // showSnackBar({
    //   mess: "Đã cập nhật",
    //   type: "success",
    // });
    // setBackdropStatus(false);
    return data;
  };

  const showSnackBar = (data) => {
    setSnackBarStatus(true);
    setSnackBarData(data);
  };

  useEffect(() => {
    checkFormStatus();
  }, [link]);

  return (
    <Layout
      snackBarStatus={snackBarStatus}
      setSnackBarStatus={setSnackBarStatus}
      snackBarData={snackBarData}
      backdropStatus={backdropStatus}
    >
      <div className={classes.page}>
        <div className={classes.container}>
          <h1>Thay ảnh bài viết</h1>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={onSubmit}
          >
            <TextField
              id="outlined-basic"
              label="Nhập link bài viết"
              onChange={(event) => {
                setLink(event.target.value);
              }}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              className="mt-4"
              startIcon={<SearchIcon />}
              disabled={formError}
              type="submit"
            >
              Tìm
            </Button>
          </form>
          {searchedState && (
            <>
              {posts && posts.length === 0 && (
                <p className="mt-5">Không có bài viết.</p>
              )}
              {posts.map((post, index) => (
                <React.Fragment key={`change-thumbnail-post-${index}-${post.id}`}>
                  <ChangeThumbnailPost
                    post={post}
                    updatePost={updatePostThumbnail}
                    updatePostCover={updatePostCover}
                    showSnackBar={showSnackBar}
                  />
                  <ChangeContentPost post={post} updatePost={updatePost} />
                </React.Fragment>
              ))}
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ToolChangeThumbnail;
